module.exports = __webpack_public_path__ + "static/media/adesivo_like.d5a1e80c.png";